import React, { useState } from "react";
import { useAuth } from "../../shared/auth/AuthProvider";
import { sendEmailVerification } from "firebase/auth";
import { auth } from "../../shared/libs/firebaseConfig";
import { useNavigate } from "react-router-dom";

export default function VerifyEmail() {
  const { user, refreshUser } = useAuth();
  const [sending, setSending] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  if (!user) {
    // ถ้าไม่ล็อกอิน → กลับไปหน้า Login
    navigate("/login");
    return null;
  }

  const resend = async () => {
    try {
      setSending(true);
      await sendEmailVerification(auth.currentUser, {
        url: "http://localhost:3001", // เปลี่ยน URL เมื่อ deploy
      });
      setMessage("✅ ส่งลิงก์ยืนยันอีกครั้งแล้ว โปรดตรวจสอบกล่องจดหมายของคุณ");
    } catch (err) {
      console.error(err);
      setMessage("❌ ส่งลิงก์ไม่สำเร็จ: " + err.message);
    } finally {
      setSending(false);
    }
  };

  const checkStatus = async () => {
    try {
      await refreshUser();
      if (auth.currentUser?.emailVerified) {
        navigate("/"); // กลับหน้าแรกเมื่อยืนยันแล้ว
      } else {
        setMessage("⚠️ ยังไม่ยืนยันอีเมล โปรดตรวจสอบอีกครั้ง");
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "calc(100vh - 160px)" }}
    >
      <div className="card shadow p-4" style={{ maxWidth: 480, width: "100%" }}>
        <h4 className="mb-3 text-center">โปรดยืนยันอีเมลของคุณ</h4>
        <p className="text-center text-muted mb-4">
          เราได้ส่งลิงก์ยืนยันไปยัง: <br />
          <strong>{user.email}</strong>
        </p>

        <div className="d-flex flex-column align-items-center gap-2">
          <button
            className="btn btn-primary w-100"
            onClick={checkStatus}
            disabled={sending}
          >
            🔄 ตรวจสอบสถานะ
          </button>
          <button
            className="btn btn-outline-secondary w-100"
            onClick={resend}
            disabled={sending}
          >
            {sending ? "กำลังส่ง..." : "✉️ ส่งลิงก์อีกครั้ง"}
          </button>
        </div>

        {message && <p className="mt-3 text-center small text-muted">{message}</p>}

        <div className="text-center mt-3">
          <button
            className="btn btn-link text-decoration-none"
            onClick={() => navigate("/logout")}
          >
            ออกจากระบบ
          </button>
        </div>
      </div>
    </div>
  );
}
